<template>
  <UiList class="py-3 bottom-item-list">
    <template v-for="(item, i) in items" :key="i">
      <UiSidebarBottomItem
        v-if="item.isVisible"
        :item="item"
        :is-sidebar-open="isSidebarOpen"
      />
    </template>
  </UiList>
</template>

<script setup lang="ts">
import UiList from '../UiList/UiList.vue';
import { type SidebarItem } from '~/app/layouts/sidebar';
import UiSidebarBottomItem from './UiSidebarBottomItem.vue';

export interface Props {
  items: SidebarItem[];
  isSidebarOpen: boolean;
}
defineProps<Props>();
</script>

<style lang="scss" scoped>
.bottom-item-list {
  background-color: transparent;
}
:deep(.v-list-item) {
  padding: 12px 0;
}
</style>
